import env from "utils/helpers/functions/env";

const currencyCode =
    env('REACT_APP_CURRENCY_CODE') ||
    env('REACT_APP_CURRENCT_CODE') ||
    'UAH';

/** Парсить REACT_APP_LANGS=ua,en */
const parseLangCodes = (raw) => {
    if (!raw || !String(raw).trim()) return null;
    const codes = String(raw)
        .split(',')
        .map((code) => code.trim().toLowerCase())
        .filter(Boolean);
    if (!codes.length) return null;
    return Array.from(new Set(codes));
};

const defaultLang = String(env('REACT_APP_DEFAULT_LANG') || 'ua').trim().toLowerCase() || 'ua';
const langs = parseLangCodes(env('REACT_APP_LANGS')) || [defaultLang];

const conf = { 
    siteUrl     : env('REACT_APP_PUBLICSITE'),   
    apiAdmin    : env('REACT_APP_APIURL'),       
    dataServer  : env('REACT_APP_DATA'),         
    googleId    : env('REACT_APP_GOOGLE_ID'),
    googleRedirectUri : env('REACT_APP_GOOGLE_REDIRECT_URI'),
    domainUuid : env('REACT_APP_DOMAIN_UUID'),
    defOptimizioWidth : 1500,
    saasMode    : env('REACT_APP_SAAS_MODE') === 'true',
    usdRate : Number(env('REACT_APP_USD_RATE')) || 0,
    currencyCode,
    currencyName: env('REACT_APP_CURRENCY_NAME') || '',
    currencySymbol: env('REACT_APP_CURRENCY_SYMBOL') || '₴',
    currencyOnce: env('REACT_APP_CURRENCY_ONCE') === 'true',
    euroMode: env('REACT_APP_EURO_MODE') === 'true',
    /** @deprecated use currencyCode; kept for tariffs fallback */
    currentCode : currencyCode,
    masterUrl   : env('REACT_APP_MASTER_URL'),
    tariffTelegram : env('REACT_APP_TARIFF_TELEGRAM') || '@e_landing',
    defLofin    : env('REACT_APP_DEF_LOGIN'),
    defPass     : env('REACT_APP_DEF_PASS'),
    tinyMode    : env('REACT_APP_TINY_MODE') === 'true',
    cloudflareMode: env('REACT_APP_CLOUDFLARE_MODE') === 'true',
    vat: Number(env('REACT_APP_VAT')) || 20,
    /** Доступні коди мов платформи (REACT_APP_LANGS). Без параметра — [defaultLang]. */
    langs,
    /** Мова за замовчуванням (REACT_APP_DEFAULT_LANG). */
    defaultLang,
    /** Ключ localStorage для збереженої мови (REACT_APP_LANG_STORAGE_KEY). */
    langStorageKey: env('REACT_APP_LANG_STORAGE_KEY') || 'lang',
    /** Ховати кнопку YouControl (REACT_APP_HIDE_YOUCONTROL=true). Без параметра — показувати. */
    hideYouControl: env('REACT_APP_HIDE_YOUCONTROL', { optional: true }) === 'true',
    /** Код країни IBAN (REACT_APP_IBAN_COUNTRY). За замовчуванням UA. */
    ibanCountry: String(env('REACT_APP_IBAN_COUNTRY', { optional: true }) || 'UA').trim().toUpperCase() || 'UA',
    /** Код країни інстансу (REACT_APP_COUNTRY). За замовчуванням ua. */
    country: String(env('REACT_APP_COUNTRY', { optional: true }) || 'ua').trim().toLowerCase() || 'ua',
} 

export default conf;
